import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/goods/shoucang-active.png'
import _imports_1 from '@/assets/image/goods/shoucang.png'
import _imports_2 from '@/assets/image/icon/search_camera.svg'


const _withScopeId = n => (_pushScopeId("data-v-3c4db9cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "similar-goods"
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "goods-img flex-ter" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "goods-desc ml_20 fx-1" }
const _hoisted_6 = { class: "mt_5 mb_10 flex price" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "mb_15 flex sell" }
const _hoisted_9 = {
  class: "label",
  style: {"width":"70px"}
}
const _hoisted_10 = { class: "favo btn flex-ter" }
const _hoisted_11 = {
  key: 0,
  src: _imports_0
}
const _hoisted_12 = {
  key: 1,
  referrerPolicy: "no-referrer",
  src: _imports_1
}
const _hoisted_13 = { style: {"margin-left":"4px"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))

import { ref, watch } from 'vue'
import { productDetail, productHasFavo } from '@/apis/search'
import useYan, { calc, formatMoneyDirection } from '@/util/useYan'
import { t } from '@/plugins/i18n'
import { confirmLogin } from '@/util/useConfirm'
import { goodsProductAdd, goodsProductCancel } from '@/apis/usercenter'
import { uploadAliOSS, GOODS_IMAGE_SEARCH } from '@/util/useUpload'
import LogoIcon from '@/components/common/LogoIcon.vue'
import { bury } from '@/util/useBury'
import { searchByImage } from '@/util/useSearchByImage'
import { isEN, useRtfix, useSite2Station } from '@/store'
import { Site } from '@/common/const'
import { getUnderLineProductPrice } from '@/views/goods/data'
import router from '@/router'

export default /*#__PURE__*/_defineComponent({
  props: ['code'],
  setup(__props) {

const props = __props
const stationCode = useSite2Station()

const product: any = ref(null)
/** 打开商品原链接 */
const openProductUrl = () => {
  if (isEN()) return
  window.open(product.value.productDetailUrl, '_blank')
}
watch(
  () => props.code,
  (productCode) => {
    product.value = null
    if (!productCode) return
    productDetail({ productCode }).then(async (res) => {
      const isfavo = await productHasFavo({ productCode }).then(
        (res) => res.data
      )
      res.data && (res.data.isfavo = isfavo)
      res.data && (res.data.yan = useYan(res.data.productSellPrice))
      product.value = getUnderLineProductPrice(res.data)
    })
  },
  { immediate: true }
)
const addFavo = (prod: any) => {
  confirmLogin(() => {
    const api = prod.isfavo ? goodsProductCancel : goodsProductAdd
    const { productCode } = prod
    api({ productCode }).then((res: any) => {
      if (res.success) prod.isfavo = !prod.isfavo
    })
  })
}

const getRangePriceByStation = (productSellPriceRange = '') => {
  const [start, end] = productSellPriceRange.split('-').map(calc)

  return [start, end].join('-')
}

return (_ctx: any,_cache: any) => {
  return (product.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              referrerPolicy: "no-referrer",
              "data-goods": "",
              src: product.value.productMainImg
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "name line--2",
              style: _normalizeStyle({ cursor: _unref(isEN)() ? '' : 'pointer' }),
              onClick: openProductUrl
            }, [
              _createVNode(LogoIcon, {
                type: product.value.platformType,
                url: product.value.productDetailUrl,
                underline: product.value.channel === 5
              }, null, 8, ["type", "url", "underline"]),
              _createTextVNode(" " + _toDisplayString(product.value.productTitle), 1)
            ], 4),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('价格')), 1),
              _createElementVNode("div", {
                class: "fee-rmb",
                style: _normalizeStyle(`color: ${_unref(stationCode) === _unref(Site).KO ? 'black' : 'red'} `)
              }, _toDisplayString(product.value.channel === 5
            ?
            product.value.finalProductSellPrice : product.value.productSellPriceRange) + _toDisplayString(_unref(t)('元')), 5),
              _createElementVNode("div", null, "(" + _toDisplayString(_unref(formatMoneyDirection)(getRangePriceByStation(String(product.value.channel === 5 ?
            product.value.finalProductSellPrice : product.value.productSellPriceRange)))) + ")", 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (
            product.value.productSellQuantity && product.value.productSellQuantity !== -1
          )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('销量')), 1),
                    _createElementVNode("div", null, _toDisplayString(product.value.productSellQuantity) + _toDisplayString(_unref(t)('件')), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addFavo(product.value))),
                class: "flex-ter"
              }, [
                (product.value.isfavo)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                  : (_openBlock(), _createElementBlock("img", _hoisted_12)),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)(product.value.isfavo ? _unref(t)('取消收藏') : _unref(t)('加入收藏夹'))), 1)
              ]),
              _createElementVNode("label", {
                for: "upload_image_research",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(bury)('ALL_Click_SearchByImage'))),
                class: "flex-ter search_camera rel cursor-pt"
              }, [
                _hoisted_14,
                _createElementVNode("span", null, _toDisplayString(_unref(t)('重新上传图片搜索')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "upload_image_research",
                  type: "file",
                  accept: "image/gif,image/png,image/jpeg,image/bmp,image/jpg",
                  onChange: _cache[1] || (_cache[1] = (e) => { _unref(searchByImage)(e.target.files[0]) })
                }, null, 544), [
                  [_vShow, false]
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})